<template>
  <d-page
    :title="$t('services.page-heading')"
    :searchToggle="searchToggle"
    @closeSearch="handleCloseSearch"
    @submitSearch="handleSubmitSearch"
  >
    <template slot="actions">
      <v-btn
        depressed
        large
        class="mr-3 mb-1 mb-sm-0"
        :class="searchToggle ? 'primary--text' : ''"
        @click="searchToggle = !searchToggle"
      >
        <v-icon left> mdi-tune </v-icon>
        <span class="subtitle-2 text-none">{{
          $t("services.button.search-toggle")
        }}</span>
      </v-btn>
      <v-btn
        color="success"
        depressed
        large
        @click="handleOpenAddOrEditModal()"
        v-granted="'service:add'"
        class="mb-1 mb-sm-0"
      >
        <v-icon left> mdi-plus </v-icon>
        <span class="subtitle-2 text-none">{{
          $t("services.button.create-item")
        }}</span>
      </v-btn>
    </template>
    <template slot="search">
      <Search :departments="departments"></Search>
    </template>
    <template slot="content">
      <List
        @editItem="handleOpenAddOrEditModal"
        @deleteItem="handleOpenDeleteModal"
        @changeStatus="handleOpenChangeStatusModal"
      ></List>
      <AddOrEdit
        v-if="openAddOrEditModal"
        :modal="openAddOrEditModal"
        :item="selectedItem"
        @closeModal="handleCloseAddOrEditModal"
        @submitModal="handleSubmitAddOrEditModal"
      ></AddOrEdit>
      <Delete
        v-if="openDeleteModal"
        :modal="openDeleteModal"
        :item="selectedItem"
        @closeModal="handleCloseDeleteModal"
        @submitModal="handleSubmitDeleteModal"
      ></Delete>
      <ChangeStatus
        v-if="openChangeStatusModal"
        :modal="openChangeStatusModal"
        :item="selectedItem"
        @closeModal="handleCloseChangeStatusModal"
        @submitModal="handleSubmitChangeStatusModal"
      ></ChangeStatus>
    </template>
  </d-page>
</template>

<script>
import List from "./List.vue";
import Search from "./Search.vue";
import AddOrEdit from "./AddOrEdit.vue";
import Delete from "./Delete.vue";
import ChangeStatus from "./ChangeStatus.vue";

export default {
  components: {
    List,
    Search,
    AddOrEdit,
    Delete,
    ChangeStatus,
  },
  data() {
    return {
      searchToggle: false,
      openDeleteModal: false,
      selectedItem: null,
      departments: [],
      openAddOrEditModal: false,
      openChangeStatusModal: false,
    };
  },
  methods: {
    handleCloseSearch() {
      this.$eventBus.$emit("fetchServices", true);
    },
    handleSubmitSearch() {
      this.$eventBus.$emit("fetchServices");
    },
    handleOpenAddOrEditModal(item = null) {
      this.openAddOrEditModal = true;
      this.selectedItem = item;
    },
    handleCloseAddOrEditModal() {
      this.openAddOrEditModal = false;
    },
    handleSubmitAddOrEditModal() {
      this.$eventBus.$emit("fetchServices");
    },
    handleOpenDeleteModal(item = null) {
      this.openDeleteModal = true;
      this.selectedItem = item;
    },
    handleCloseDeleteModal() {
      this.openDeleteModal = false;
    },
    handleSubmitDeleteModal() {
      this.$eventBus.$emit("fetchServices");
    },
    handleOpenChangeStatusModal(item = null) {
      this.openChangeStatusModal = true;
      this.selectedItem = item;
    },
    handleCloseChangeStatusModal() {
      this.openChangeStatusModal = false;
    },
    handleSubmitChangeStatusModal() {
      this.$eventBus.$emit("fetchServices");
    },
    fetchAllDepartments() {
      window.API.fetchAllDepartments()
        .then((response) => {
          this.departments = response;
        })
        .catch(() => this.showFetchRequestErrorMessage());
    },
  },
  async mounted() {
    await this.fetchAllDepartments();
  },
};
</script>
